import { render, staticRenderFns } from "./ChatBody.vue?vue&type=template&id=3b9b936a"
import script from "./ChatBody.vue?vue&type=script&lang=ts"
export * from "./ChatBody.vue?vue&type=script&lang=ts"
import style0 from "./ChatBody.vue?vue&type=style&index=0&id=3b9b936a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports